import KunLoading40 from './src/index'

KunLoading40.install = function (Vue) {
	Vue.component(KunLoading40.name, KunLoading40);
}

export default KunLoading40;
